const data =  [
    {
        title: "L'Escala",
        location: "Spain",
        googleMapsUrl: "https://goo.gl/maps/r6c8ibig59wHaZ6A8",
        startDate: "17 Aug, 2021",
        endDate: "26 Aug, 2021",
        description: "L’Escala is a charming fishing village that sits on one of the “most beautiful bays in the world”, according to UNESCO. Lined with beautiful, sandy beaches, somehow the traditional Catalan town has eluded the onslaught of tourism you’ll find in some other spots along the Costa Brava. An hour and a half from Barcelona and less than an hour from Girona’s International airport, the quiet town offers a secluded Mediterranean retreat that’s also easily accessible.",
        imageUrl: "https://source.unsplash.com/hm5G6DDPU2s",
        visited: true
    },
    {
        title: "Paramaribo",
        location: "Suriname",
        googleMapsUrl: "https://goo.gl/maps/ChJKnWwZ65e8CQHG8",
        startDate: "14 Oct, 2017",
        endDate: "21 Oct, 2017",
        description: "Paramaribo is the capital city of Suriname on the banks of the Suriname River. It’s known for ornate wooden Dutch colonial buildings in its center. On the banks of the river, the 17th-century Fort Zeelandia houses the Surinaams Museum, with exhibits on the region's history. Nearby, the wood-and-stone Presidential Palace faces Independence Square and is backed by the Garden of Palms, a public park.",
        imageUrl: "https://live.staticflickr.com/2868/11407931953_5391a881cd_k_d.jpg",
        visited: true
    },
    {
        title: "Fushimi Inari-taisha",
        location: "Japan",
        googleMapsUrl: "https://goo.gl/maps/yVVdqqr1JvXZwAg86",
        description: "Fushimi Inari Shrine (伏見稲荷大社, Fushimi Inari Taisha) is an important Shinto shrine in southern Kyoto. It is famous for its thousands of vermilion torii gates, which straddle a network of trails behind its main buildings. The trails lead into the wooded forest of the sacred Mount Inari, which stands at 233 meters and belongs to the shrine grounds.",
        imageUrl: "https://source.unsplash.com/N9s3WOcDCzU",
        visited: false
    },
    {
        title: "Niagara Falls",
        location: "Canada",
        googleMapsUrl: "https://goo.gl/maps/1RdTKJuBgbt6StSJ9",
        description: "Niagara Falls, Ontario, is a Canadian city at the famous waterfalls of the same name, linked with the U.S. by the Rainbow Bridge. Its site on the Niagara River's western shore overlooks the Horseshoe Falls, the cascades' most expansive section. Elevators take visitors to a lower, wetter vantage point behind the falls. A cliffside park features a promenade alongside 520-ft.-high Skylon Tower with an observation deck.",
        imageUrl: "https://source.unsplash.com/168YNGX3UYo",
        visited: false
    },
    {
        title: "Petra",
        location: "Jordan",
        googleMapsUrl: "https://goo.gl/maps/jouDKUSjpFcxn2fR8",
        description: "Petra is a famous archaeological site in Jordan's southwestern desert. Dating to around 300 B.C., it was the capital of the Nabatean Kingdom. Accessed via a narrow canyon called Al Siq, it contains tombs and temples carved into pink sandstone cliffs, earning its nickname, the \"Rose City.\" Perhaps its most famous structure is 45m-high Al Khazneh, a temple with an ornate, Greek-style facade, and known as The Treasury.",
        imageUrl: "https://assets.vogue.in/photos/5cfa5b40d2c61977d5172477/original/original/Jordan.jpg",
        visited: false
    },
    {
        title: "Grand Canyon",
        location: "USA",
        googleMapsUrl: "https://goo.gl/maps/KizVZUCBZkirGTQu6",
        description: "Grand Canyon National Park, in Arizona, is home to much of the immense Grand Canyon, with its layered bands of red rock revealing millions of years of geological history. Viewpoints include Mather Point, Yavapai Observation Station and architect Mary Colter’s Lookout Studio and her Desert View Watchtower. Lipan Point, with wide views of the canyon and Colorado River, is a popular, especially at sunrise and sunset.",
        imageUrl: "https://source.unsplash.com/7he8rO3qdsc",
        visited: false
    }
]

export default data